import { Apuracao } from '@/types/apuracao'
import { atom } from 'jotai'

export const apuracaoAtom = atom<Apuracao | null>(null)
